export default {
  id: null,
  empresaID: null,
  secaoRHID: null,
  contaID: null,
  email: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/coordinatormodel.js